import { useState } from "react"
import { makeStyles } from "tss-react/mui"
import SearchIcon from "@mui/icons-material/Search"
import { Box, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from "@mui/material"
import { useDebouncedInput } from "../../../../../../shared/hooks/useDebouncedInput"

const useStyles = makeStyles()((theme) => ({
    container: {
        position: "relative",
        maxWidth: "100%",
    },
    inputRoot: {
        width: 0,
        transition: "width 0.3s ease-out",
        "& input": {
            width: "100%",
            paddingRight: 0,
        },
        "& fieldset": {
            transition: "all 0.3s ease-out",
            opacity: 0,
        },
    },
    expandedInput: {
        width: "20rem",
        "& fieldset": {
            opacity: "100%",
        },
        "& input": {
            paddingRight: "2.75rem",
        },
    },
    iconButton: {
        position: "absolute",
        right: 2,
        zIndex: 1,
    },
}))
type ExpandableSearchProps = {
    value: string
    onChange: (value: string) => void
    label: string
    placeholder?: string
}

export const ExpandableSearch = ({ value, onChange, label, placeholder = "" }: ExpandableSearchProps) => {
    const { classes, cx } = useStyles()
    const { innerValue, setInnerValue } = useDebouncedInput(value, onChange)
    const [expanded, setExpanded] = useState(false)

    const toggleExpand = () => {
        setExpanded((prev) => !prev)
    }

    return (
        <FormControl className={classes.container}>
            <InputLabel>{label}</InputLabel>
            <OutlinedInput
                className={cx(classes.inputRoot, { [classes.expandedInput]: expanded })}
                startAdornment={
                    <InputAdornment position="start">
                        <IconButton onClick={toggleExpand} edge="start" className={classes.iconButton}>
                            <SearchIcon />
                        </IconButton>
                    </InputAdornment>
                }
                value={innerValue}
                onChange={(e) => setInnerValue(e.target.value)}
                label={label}
                placeholder={expanded ? placeholder : ""}
            />
        </FormControl>
    )
}
